import styled from 'styled-components';
import { gridSizes } from 'utils/style';
import GDPROptions from 'components/summary/GDPROptions/container';

export default styled(GDPROptions)`
  color: var(--grey700);
  a {
    color: var(--primary500);
    font-size: ${gridSizes('M')};
    &:hover {
      color: var(--primary500);
    }
  }
  .summary-legal-link {
    display: inline;
  }

  .option {
    display: flex;
    margin-top: ${gridSizes('M')};
    margin-bottom: ${gridSizes('L')};

    label {
      margin-right: ${gridSizes('S')};
    }

    .label {
      text-align: left;
    }
  }
`;
